export const isValueNotPresentInOptions = (value, options, optionsValueKey = 'value') => {
    return value && options && options.length > 0 && !options.find((item) => value === item[optionsValueKey]);
};
//# sourceMappingURL=is-value-not-present-in-options.js.map